package br.gov.go.pge.permanenciaweb.site.components

import androidx.compose.runtime.Composable
import org.jetbrains.compose.web.dom.AttrBuilderContext
import org.jetbrains.compose.web.dom.ContentBuilder
import org.jetbrains.compose.web.dom.ElementBuilder
import org.jetbrains.compose.web.dom.TagElement
import org.w3c.dom.HTMLElement

/*
 * Compose HTML 1.11.1 is missing a helper for the `<strong>` element the old static UI used.
 * This is a plain `TagElement` wrapper, no extra behavior.
 */

/** `<strong>` element (Compose HTML only ships `B`). */
@Composable
fun Strong(
    attrs: AttrBuilderContext<HTMLElement>? = null,
    content: ContentBuilder<HTMLElement>? = null,
) = TagElement(
    elementBuilder = ElementBuilder.createBuilder<HTMLElement>("strong"),
    applyAttrs = attrs,
    content = content,
)

/**
 * Tiny holder so document-level listeners can see the latest element instance without
 * recomposing (used by popup trigger/popup pairs to detect outside clicks).
 */
class ElementHolder<T : HTMLElement> {
    var element: T? = null
}
